import { useState } from "react";
import { GENRE_COLORS } from "../data/constants";
import MiniBook from "./MiniBook";
import { MonthlyStatsLauncher } from "./MonthlyStats";
import { keyOf } from "../utils/monthlyStats";
import "./UserBooksView.css";

const UserBooksView = ({ books, viewType, onBookClick, sharedBookIds = [], showWishlist = false, isInWishlist, onToggleWishlist, viewUserId, viewUserName, canExport }) => {
  const [monthYearFilter, setMonthYearFilter] = useState("all");
  const [genreFilter, setGenreFilter] = useState("all");
  const group = (key) => books.reduce((acc, b) => {
    (acc[b[key]] = acc[b[key]] || []).push(b); return acc;
  }, {});

  const MB = (b) => <MiniBook key={b.id} book={b} onClick={onBookClick} isShared={sharedBookIds.includes(b.id)}
    isRecommended={!!(viewUserId && b.recommendedBy && b.recommendedBy[viewUserId])}
    showWishlist={showWishlist} isWishlisted={isInWishlist ? isInWishlist(b.id) : false} onToggleWishlist={onToggleWishlist} />;

  if (viewType === "genre") {
    const genres = Object.entries(group("genre")).sort((a, b) => b[1].length - a[1].length);
    const filtered = genreFilter === "all" ? genres : genres.filter(([g]) => g === genreFilter);
    return (
      <div>
        {genres.length > 1 && (
          <div className="orbit-year-tabs" style={{ padding: "0 0 .8rem" }}>
            <button className={`orbit-year-tab${genreFilter === "all" ? " active" : ""}`} onClick={() => setGenreFilter("all")}>전체</button>
            {genres.map(([g, bks]) => (
              <button key={g} className={`orbit-year-tab${genreFilter === g ? " active" : ""}`} onClick={() => setGenreFilter(g)}>
                {g} {bks.length}
              </button>
            ))}
          </div>
        )}
        {filtered.map(([g, bks]) => (
          <div key={g} className="genre-section">
            <div className="genre-header">
              <div className="genre-dot" style={{ background: GENRE_COLORS[g] || "#aaa" }} />
              <span className="genre-name">{g}</span>
              <span className="genre-count">{bks.length}권</span>
            </div>
            <div className="genre-books">{bks.map(b => MB(b))}</div>
          </div>
        ))}
      </div>
    );
  }
  if (viewType === "author") {
    return <div>{Object.entries(group("author")).map(([a, bks]) => (
      <div key={a} className="genre-section">
        <div className="genre-header">
          <div className="genre-dot" style={{ background: "#c47a6b" }} />
          <span className="genre-name">✍️ {a}</span>
          <span className="genre-count">{bks.length}권</span>
        </div>
        <div className="genre-books">{bks.map(b => MB(b))}</div>
      </div>
    ))}</div>;
  }
  if (viewType === "month") {
    /* 완독일로 나눈다 — 위 카드, 홈의 '올해 N권' 과 같은 기준이다.
       예전엔 시작일로 나눠, 8월에 시작해 9월에 다 읽은 책이 8월에 있었다.
       아직 다 읽지 않은 책은 달이 없으므로 맨 아래 '읽는 중' 으로 모은다. */
    const monthGroup = {};
    const yearSet = new Set();
    const reading = [];
    const doneOf = (b) => String(b.completedBy?.[viewUserId] ?? "");
    books.forEach(b => {
      const k = keyOf(doneOf(b));
      if (!k) { reading.push(b); return; }
      (monthGroup[k] = monthGroup[k] || []).push(b);
      yearSet.add(k.slice(0, 4));
    });
    const years = [...yearSet].sort().reverse();
    const filtered = Object.entries(monthGroup)
      .filter(([m]) => monthYearFilter === "all" || m.startsWith(monthYearFilter))
      .sort((a, b) => b[0].localeCompare(a[0]));
    return (
      <div>
        <MonthlyStatsLauncher books={books} uid={viewUserId} name={viewUserName}
          onBookClick={onBookClick} canExport={canExport} />
        {years.length > 1 && (
          <div className="orbit-year-tabs" style={{ padding: "0 0 .8rem" }}>
            <button className={`orbit-year-tab${monthYearFilter === "all" ? " active" : ""}`} onClick={() => setMonthYearFilter("all")}>전체</button>
            {years.map(y => (
              <button key={y} className={`orbit-year-tab${monthYearFilter === y ? " active" : ""}`} onClick={() => setMonthYearFilter(y)}>{y}</button>
            ))}
          </div>
        )}
        <div className="timeline">
          {filtered.map(([m, bks]) => (
            <div key={m} className="timeline-year">
              <div className="timeline-dot" />
              <div className="timeline-year-label">{m.replace("-", ".")}</div>
              <div className="genre-books">
                {[...bks].sort((x, y) => doneOf(y).localeCompare(doneOf(x))).map(b => MB(b))}
              </div>
            </div>
          ))}
          {reading.length > 0 && monthYearFilter === "all" && (
            <div className="timeline-year">
              <div className="timeline-dot" />
              <div className="timeline-year-label">읽는 중</div>
              <div className="genre-books">{reading.map(b => MB(b))}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default UserBooksView;
